import {
  InputTextProps,
  InputTextComponentInnerProps,
  InputTextStyledComponentProps,
  InputTextTypes,
} from "./types"
import React from "react"
import { TextInput, View } from "~/ui/primitives"
import { InputTextCore } from "./core"
import { FeildFloatLabel } from "~widgets/feild-float-label"
import styled from '~/ui/styled'
import { webInputStyles } from "~/ui/web-controls"
import { ColumnFlex } from "~components/El"

const StyledTextInput = styled(TextInput)<InputTextStyledComponentProps>`
  border-radius: ${({ theme }) => theme.radii.lg};
  color: ${({ theme }) => theme.colors.text};
  ${webInputStyles}
`

const RequiredMark = styled.Text`
  color: ${({ theme }) => theme.colors.error};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`

export const InputTextFloatLabelInnerUnrefed: React.ForwardRefRenderFunction<
  TextInput,
  InputTextComponentInnerProps
> = ({ label, required, rightAccessory, ...rest }, ref) => {
  //required 只控制标签显示*
  const accessoryPaddingRight = 40

  const input = rightAccessory ? (
    <ColumnFlex style={{ position: "relative", width: "100%", height: 48 }}>
      <StyledTextInput
        {...rest}
        ref={ref}
        style={ { paddingRight: 12 + accessoryPaddingRight }}
      />
      <View
        pointerEvents="box-none"
        style={{
          position: "absolute",
          right: 4,
          // top: 0,
          height:48,
          bottom: 0,
          width: accessoryPaddingRight,
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
        }}
      >
        {rightAccessory}
      </View>
    </ColumnFlex>
  ) : (
    <StyledTextInput {...rest} ref={ref} />
  )
  return (
    <>
      {!!label && (
        <FeildFloatLabel>
          {required ? <RequiredMark>* </RequiredMark> : null}
          {label}
        </FeildFloatLabel>
      )}
      {input}
    </>
  )
}

export const InputTextFloatLabelInner = React.forwardRef(InputTextFloatLabelInnerUnrefed)

const InputTextFloatLabel: React.ForwardRefRenderFunction<TextInput, InputTextProps> = (
  { label, validRule, rightAccessory, ...rest },
  ref,
) => {
  return (
    <InputTextCore
      {...rest}
      label={label}
      validRule={validRule}
      rightAccessory={rightAccessory}
      type={InputTextTypes.INPUT_TEXT_FLOAT_LABEL}
      ref={ref}
    ></InputTextCore>
  )
}

export default React.forwardRef(InputTextFloatLabel)
